import React, { useState, useEffect, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import Accordion from "react-bootstrap/Accordion";
import Modal from "react-bootstrap/Modal";
import { useCoupon } from "./couponContext";
import Slider from "react-slick";
import { URLS } from "../Url";
import Footer from "./Footer";
import Header from "./Header";
import Typer from "./Typer";
import axios from "axios";
import roses from "./images/roses.jpg";
import cake4 from "./images/cake 4.jpg";
import { FaStar } from "react-icons/fa";
import { Galleria } from "primereact/galleria";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import beverages from "./images/foodbeverages.jpg";
import screening from "./images/screening.jpg";
import { useNavigate } from 'react-router-dom';
import { Helmet } from "react-helmet";
import {
  faUser,
  faPhone,
  faEnvelope,
  faCalendarAlt,
  faClipboard,
} from "@fortawesome/free-solid-svg-icons";
import logo from "./images/Bingenjoylogopng.png";
import load from "./images/Bingenjoylogopng.png";

/*images */
import basicPackageImg from "./images/cake 4.jpg";
import comboPackageImg from "./images/cake 4.jpg";

import { Carousel, Card, Container, Row, Col, Button } from "react-bootstrap";
import TheaterDetails from "../pages/TheaterDetails";
import CouponSection from "../pages/Coupons";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";

function Home() {

  const [isLoading, setIsLoading] = useState(false);
  const { couponCode, handleCouponChange } = useCoupon(); // Access context
  const navigate = useNavigate();



  const [form, setform] = useState({
    name: "",
    email: "",
    mobileNumber: "",
    description: "",
    eventName: "",
  });

  useEffect(() => {
    GetHomePage();
    GetAllGalleryDate();
  }, []);

  const [Faqs, setFaqs] = useState([]);
  const [Sliders, setSliders] = useState([]);
  console.log(Sliders);
  const [Howtojoin, setHowtojoin] = useState([]);
  const [LatestInfo, setLatestInfo] = useState([]);
  const [LatestInfos, setLatestInfos] = useState([]);
  console.log(LatestInfos);
  const [Highlights, setHighlights] = useState([]);
  // const [Testimonial, setTestimonial] = useState([]);
  const [Howtojoinpoints, setHowtojoinpoints] = useState([]);
  const [HighlightsPoints, setHighlightsPoints] = useState([]);

  const [Offers, setOffers] = useState([]);
  const [services, setservices] = useState([]);

  const [Contact, setContact] = useState([]);


  const GetHomePage = () => {
    axios.post(URLS.AllModules, {}, {}).then((res) => {
      if (res.status === 200) {
        setFaqs(res?.data?.faqs);
        setContact(res?.data?.contactus[0]);
        setSliders(res?.data?.homesliders);
        // setTestimonial(res?.data?.testimonials);
        setHowtojoin(res?.data?.howtojoin[0]);
        setHighlights(res?.data?.highlight[0]);
        setLatestInfo(res?.data?.latestinfo[0]);
        setLatestInfos(res?.data?.latestinfo[0]?.count);
        setHighlightsPoints(res?.data?.highlight[0]?.features);
        setHowtojoinpoints(res?.data?.howtojoin[0]?.benefits);
        setPopUp(res?.data?.popup[0]);
        setOffers(res?.data?.offer);
        setservices(res?.data?.occasions);
        setLgShow(res?.data?.popup[0]?.popupBoolean);
        setIsLoading(false);
      }
    });
    sessionStorage.clear();
  };

  const formsubmit = (e) => {
    e.preventDefault();
    EnquiryNow();
  };

  const handleChange = (e) => {
    let myUser = { ...form };
    myUser[e.target.name] = e.target.value;
    setform(myUser);
  };

  const EnquiryNow = () => {
    const dataArray = {
      name: form.name,
      email: form.email,
      mobileNumber: form.mobileNumber,
      description: form.description,
      eventName: form.eventName,
    };




    axios.post(URLS.AddEnquiry, dataArray).then(
      (res) => {
        if (res.status === 200) {
          toast(res.data.message);
          setform({
            name: "",
            email: "",
            mobileNumber: "",
            description: "",
            eventName: "",
          });
        }
      },
      (error) => {
        if (error.response && error.response.status === 400) {
          toast(error.response.data.message);
        }
      }
    );
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  };

  const settings4 = {
    dots: false,
    infinite: true,
    arrows: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          arrows: false,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          infinite: true,
          arrows: false,
          dots: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          arrows: false,
          dots: false,
        },
      },
    ],
  };

  const settings2 = {
    dots: false,
    infinite: true,
    arrows: true,
    autoplay: false,
    speed: 1000,
    // slidesToShow: 4,
    slidesToShow: 2,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const settings3 = {
    dots: false,
    autoplay: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const [images, setImages] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const [displayImages, setDisplayImages] = useState([]);

  const GetAllGalleryDate = () => {
    axios.post(URLS.GetAllGallery, {}, {}).then((res) => {
      if (res.status === 200) {
        const galleryData = res?.data?.gallerys || [];
        setImages(galleryData);
        setDisplayImages(galleryData.slice(0, 3)); // Show first 3 initially
      }
    });
  };

  useEffect(() => {
    GetAllGalleryDate();
  }, []);

  const toggleShowAll = () => {
    setShowAll(!showAll);
    if (!showAll) {
      setDisplayImages(images); // Show all
    } else {
      setDisplayImages(images.slice(0, 3)); // Collapse to first 3
    }
  };

  // Static array of coupon codes, each coupon has its unique code
  const couponCodesArray = [
    'BIRT20',
    'ANNI15',
    'GROP25',
    'PRIVA10',
  ];

  const [activeIndex, setActiveIndex] = useState(0);
  const galleria = useRef(null);

  const itemTemplate = (item) => {
    return (
      <img
        src={URLS.Base + item.image}
        alt={item.alt}
        style={{ width: "100%", display: "block" }}
      />
    );
  };

  const thumbnailTemplate = (item) => {
    return (
      <img
        src={URLS.Base + item.image}
        alt={item.alt}
        style={{ display: "block" }}
      />
    );
  };

  const [timeLeft, setTimeLeft] = useState(39639);

  useEffect(() => {
    if (timeLeft <= 0) return;
    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);
    return () => clearInterval(intervalId);
  }, [timeLeft]);

  const formatTime = (time) => {
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = time % 60;
    return {
      hours: hours.toString().padStart(2, "0"),
      minutes: minutes.toString().padStart(2, "0"),
      seconds: seconds.toString().padStart(2, "0"),
    };
  };

  const { hours, minutes, seconds } = formatTime(timeLeft);

  const [Theaters, setTheaters] = useState([]);

  const [hoveredIndex, setHoveredIndex] = useState(null);

  useEffect(() => {
    GetTheatersData();
  }, []);

  const GetTheatersData = () => {
    axios.post(URLS.GetAllTheaters, {}, {}).then((res) => {
      if (res.status === 200) {
        setTheaters(res.data.theatres);
      }
    });
  };

  const today = new Date();

  const [date, setDate] = useState(today);

  const dateString = date;

  const dateObject = new Date(dateString);

  const dd = dateObject.getDate().toString().padStart(2, "0");
  const mm = (dateObject.getMonth() + 1).toString().padStart(2, "0");
  const yyyy = dateObject.getFullYear();

  const formattedDateString = `${yyyy}-${mm}-${dd}`;

  const databyid = (data) => {
    sessionStorage.clear();
    axios.post(URLS.GetUnicId, {}, {}).then((res) => {
      if (res.status === 200) {
        sessionStorage.setItem("UserId", res.data.userId);
        sessionStorage.setItem("Theaterid", data._id);
        sessionStorage.setItem("theatreName", data.name);
        sessionStorage.setItem("theatrePrice", data.offerPrice);
        sessionStorage.setItem("date", formattedDateString);
        window.location.href = "/BookingDetails";
      }
    });
  };

  const navigateTheater = useNavigate();
  const handleTheater = () => {
    navigateTheater("./theaters");
  };

  const handleCouponClick = (code) => {
    handleCouponChange(code); // Update the coupon code in global state
  };



  const [PopUp1, setPopUp1] = useState([]);

  useEffect(() => {
    GetFooterData();
  }, []);

  const GetFooterData = () => {
    axios.post(URLS.GetFooter, {}, {}).then((res) => {
      if (res.status === 200) {
        setContact(res.data.contactus);
        setPopUp1(res.data.popup[0]);
      }
    });
  };

  // Static data for packages
  const packages = [
    {
      id: 1,
      title: "Basic Plan",
      price: "2149",
      subtitle: "Simple theatre slot, no setup",
      detailedFeatures: {
        "Theatre Hall": true,
        "Decoration": true,
        "Fog Entry (1 Pot)": false,
        "Candle Path": false,
        "HBD LED": false,
        "Name with LED (6)": false,
        "AGE Number LED": false,
        "HBD with Rose petals": false,
        "Photo Clipping (10)": false,
        "Birthday Sash": false,
        "Birthday Crown, Spects": false,
        "Rose Bouquet (12 Roses)": false,
        "Customisation cake (1 kg)": false,
        "Photography (30 Mins)": false,
        "Cold fire entry (6 pieces)": false,
        "Videography(Edited 1 Min Reel)": false,
        "Hall fog (4 Pots)": false,
      },
      badgeText: "Saved ₹0",
      buttonText: "Proceed →",
    },
    {
      id: 2,
      title: "Standard Plan",
      subtitle: "Includes cake, lights & decor.",
      detailedFeatures: {
        "Theatre + Decoration": true,
        "Fog Entry (1 Pot)": true,
        "Candle Path": true,
        "HBD LED": true,
        "Name with LED (6)": true,
        "AGE Number LED": true,
        "HBD with Rose Petals": true,
        "Photo Clipping (10)": true,
        "Birthday Sash": true,
        "Birthday Crown, Spects": true,
        "Rose": true,
        "Regular Cake - 1/2 kg": true,
        "Photography (15 Mins)": true,
        "Cold fire entry (6 pieces)": false,
        "Videography(Edited 1 Min Reel)": false,
        "Hall fog (4 Pots)": false,
      },
      badgeText: "Save ₹200",
      buttonText: "Proceed →",
    },
    {
      id: 3,
      title: "Special Plan",
      subtitle: "Our grandest experience, full royal vibes.",
      detailedFeatures: {
        "Theatre + Decoration": true,
        "Fog Entry (1 Pot)": true,
        "Candle Path": true,
        "HBD LED": true,
        "Name with LED (6)": true,
        "AGE Number LED": true,
        "HBD with Rose petals": true,
        "Photo Clipping (10)": true,
        "Birthday Sash": true,
        "Birthday Crown, Spects": true,
        "Rose Bouquet (6 Roses)": true,
        "Customisation cake (1 kg)": true,
        "Photography (30 Mins)": true,
        "Cold fire entry (4 pieces)": true,
        "Videography(Edited 1 Min Reel)": false,
        "Hall fog (4 Pots)": false,
      },
      badgeText: "Save ₹400",
      buttonText: "Proceed →",
    },
    {
      id: 4,
      title: "Premium Plan",
      subtitle: "More guests, more upgrades, more glam.",
      detailedFeatures: {
        "Theatre + Decoration": true,
        "Fog Entry (1 Pot)": true,
        "Candle Path": true,
        "HBD LED": true,
        "Name with LED (6)": true,
        "AGE Number LED": true,
        "HBD with Rose petals": true,
        "Photo Clipping (10)": true,
        "Birthday Sash": true,
        "Birthday Crown, Spects": true,
        "Rose Bouquet (12 Roses)": true,
        "Customisation cake (1 kg)": true,
        "Photography (30 Mins)": true,
        "Cold fire entry (6 pieces)": true,
        "Videography(Edited 1 Min Reel)": true,
        "Hall fog (4 Pots)": true,
      },
      badgeText: "Save ₹300",
      buttonText: "Proceed →",
    },
  ];




  const Reviews = [
    {
      name: 'G. Harish',
      location: 'Gachibowli, Hyderabad',
      rating: 5,
      description: 'We had the best birthday surprise ever! The theatre was beautifully set up and everything was perfect.',
      occasion: "Daughter’s 1st Birthday",
      avatar: 'https://i.ibb.co/4Vb94bc/harish-avatar.png',
      image: 'https://api.carnivalcastle.com/uploads/galleryImg/1728132803817-DSC07593.jpg',
    },
    {
      name: 'Ravi Kumar',
      location: 'Jubilee Hills, Hyderabad',
      rating: 4,
      description: 'Wonderful experience. Everything was well arranged and exceeded expectations!',
      occasion: 'Wedding Anniversary',
      avatar: 'https://i.ibb.co/4Vb94bc/harish-avatar.png',
      image: 'https://api.carnivalcastle.com/uploads/galleryImg/1728132797148-DSC07601.jpg',
    },
    {
      name: 'Sneha Sharma',
      location: 'Kondapur, Hyderabad',
      rating: 5,
      description: 'It felt so personal and beautiful. Loved the decorations and ambience.',
      occasion: 'Valentine’s Day',
      avatar: 'https://i.ibb.co/4Vb94bc/harish-avatar.png',
      image: 'https://api.carnivalcastle.com/uploads/galleryImg/1728132803817-DSC07593.jpg',
    },
    {
      name: 'Rahul Verma',
      location: 'Banjara Hills, Hyderabad',
      rating: 5,
      description: 'Our celebration turned out to be magical, thanks to the amazing setup and staff!',
      occasion: 'Baby Shower',
      avatar: 'https://i.ibb.co/4Vb94bc/harish-avatar.png',
      image: 'https://api.carnivalcastle.com/uploads/galleryImg/1728132797148-DSC07601.jpg',
    },
    {
      name: 'Aarti Nair',
      location: 'Madhapur, Hyderabad',
      rating: 4,
      description: 'Highly recommend this place! The ambiance was perfect for our celebration.',
      occasion: 'Engagement',
      avatar: 'https://i.ibb.co/4Vb94bc/harish-avatar.png',
      image: 'https://api.carnivalcastle.com/uploads/galleryImg/1728132803817-DSC07593.jpg',
    },
    {
      name: 'Vikram Singh',
      location: 'Hi-Tech City, Hyderabad',
      rating: 5,
      description: 'Superb arrangements. The staff was very friendly and everything went smoothly.',
      occasion: 'Retirement Party',
      avatar: 'https://i.ibb.co/4Vb94bc/harish-avatar.png',
      image: 'https://api.carnivalcastle.com/uploads/galleryImg/1728132797148-DSC07601.jpg',
    },
  ];

  const chunkArray = (arr, size) =>
    Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
      arr.slice(i * size, i * size + size)
    );

  const isMobile = window.innerWidth < 768;
  // const slides = chunkArray(Reviews, isMobile ? 1 : 3);



  const [index, setIndex] = useState(0);
  const intervalRef = useRef(null);

  const startAutoRotate = () => {
    intervalRef.current = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % whyUsSlides.length);
    }, 6000);
  };

  const stopAutoRotate = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
  };

  useEffect(() => {
    startAutoRotate();
    return () => stopAutoRotate();
  }, []);

  const handleSelect = (selectedIndex) => {
    stopAutoRotate();
    setIndex(selectedIndex);
    startAutoRotate(); // restart timer on manual select
  };
  const whyUsSlides = [
    {
      image: URLS?.Base + Highlights?.image, // Replace with dynamic images
      title: "Why Choose BingeNJoy Private Theatre?",
      subtitle:
        "At BingeNJoy, we believe every celebration deserves a cinematic experience — intimate, exclusive and unforgettable. Here’s why our private theatre stands out:",
      points: [
        "Perfect for Every Occasion: Themed decorations, cakes, fog effects & photography.",
        "Luxurious Ambience: Recliners, premium sound, elegant decor.",
        "Budget-Friendly Luxury: Combo offers & rewards for every budget.",
        "Prime Location in Hyderabad: Easily accessible, cozy, and convenient.",
        "End-to-End Convenience: WhatsApp support, décor add-ons & great food."
      ]
    },
    {
      image: "https://api.carnivalcastle.com/uploads/galleryImg/1728132797148-DSC07601.jpg", // Replace with another image
      title: "Celebrate Cinematically!",
      subtitle:
        "Experience celebrations like never before in our private theatres — where entertainment meets exclusivity.",
      points: [
        "Customizable Packages: Tailor your party exactly how you like it.",
        "Gourmet Snacks & Beverages: From popcorn to premium platters.",
        "Full HD Projector & Sound: A real theatre vibe, privately yours.",
        "Cozy for Everyone: Perfect for couples, families, and friends.",
        "Hassle-Free Booking: Fast, flexible & fully digital!"
      ]
    },
    {
      image: "https://api.carnivalcastle.com/uploads/galleryImg/1728132803817-DSC07593.jpg", // Replace with another image
      title: "Make Every Moment Magical",
      subtitle:
        "From surprise proposals to baby showers — bring your vision to life in an immersive, themed theatre setting.",
      points: [
        "Baby Showers, Anniversaries & More: Celebrate every milestone.",
        "Themed Decor & Props: Transform the space into your dream setting.",
        "Memorable Photo Zones: Instagram-worthy backdrops included.",
        "Night or Day Slots: Flexible celebration timings.",
        "Personalized Assistance: Our team helps plan every detail."
      ]
    }
  ];

  const [testimonials, setTestimonials] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const res = await axios.post(
          "https://api.carnivalcastle.com/v1/carnivalApi/admin/testimonial/getalltestimoni?websiteFor=bingenjoy"
        );

        if (res.data?.success && Array.isArray(res.data.testimoni)) {
          // ✅ Only include testimonials that are active and have a valid videoId
          const videoTestimonials = res.data.testimoni.filter(
            (t) =>
              t.status === "active" &&
              t.videoId &&
              t.videoId.trim() !== ""
          );

          setTestimonials(videoTestimonials);
          console.log("Video Testimonials:", videoTestimonials);

          // ✅ Set first video testimonial as default selected
          if (videoTestimonials.length > 0) {
            setSelected(videoTestimonials[0]);
          }
        }
      } catch (err) {
        console.error("Error fetching testimonials:", err);
      }
    };

    fetchTestimonials();
  }, []);

  const [slides, setSlides] = useState([]);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const res = await axios.post(
          "https://api.carnivalcastle.com/v1/carnivalApi/admin/testimonial/getalltestimoni?websiteFor=bingenjoy"
        );

        if (res.data?.success && Array.isArray(res.data.testimoni)) {
          // ✅ Filter only active + with videoId
          const filtered = res.data.testimoni.filter(
            (t) => t.status === "active" && t.videoId
          );

          // ✅ Map API fields to front-end fields
          const formatted = filtered.map((t) => ({
            name: t.name,
            location: t.role || "Customer",
            rating: Number(t.rating) || 5,
            description: t.description || "",
            image: `https://api.carnivalcastle.com/${t.image}`,
            avatar: `https://api.carnivalcastle.com/${t.profileImage}`, // using same image as avatar
            occasion: t.type === "Yes" ? "Special Celebration" : "",
          }));

          // ✅ Group into slides of 3 per slide
          const grouped = [];
          for (let i = 0; i < formatted.length; i += 3) {
            grouped.push(formatted.slice(i, i + 3));
          }

          setSlides(grouped);
        }
      } catch (err) {
        console.error("Error fetching testimonials:", err);
      }
    };

    fetchTestimonials();
  }, []);


  const BaseUrl = "https://api.carnivalcastle.com/v1/carnivalApi/";
  const ImageBase = "https://api.carnivalcastle.com/";

  const [addresses, setAddresses] = useState([]);

  useEffect(() => {
    const fetchAddresses = async () => {
      try {
        const res = await axios.get(`${BaseUrl}admin/address/alladdress`);
        if (res.data && res.data.success) {
          setAddresses(res.data.data || []);
        } else {
          setAddresses([]);
        }
      } catch (error) {
        console.error("Error fetching addresses:", error);
        setAddresses([]);
      }
    };
    fetchAddresses();
  }, []);

  const [lgvis, setLgVis] = useState(false);

  const modelShow = () => {
    setLgVis(!false);
  };

  const [occasions, setOccasions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOccasions = async () => {
      try {
        const response = await axios.post(URLS.GetAllOccation, {});
        if (response.status === 200) {
          setOccasions(response.data?.occasions || []);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchOccasions();
  }, []);



  const [lgShow, setLgShow] = useState(false);
  const [PopUp, setPopUp] = useState({});

  useEffect(() => {
    if (lgShow) {
      window.scrollTo(0, 0);
    }
  }, [lgShow]);


  useEffect(() => {
    // First check if popup should be shown at all
    const hasSeenPopup = localStorage.getItem('hasSeenPopup');

    // Only proceed if popup hasn't been seen before
    if (!hasSeenPopup) {
      axios.get(URLS.GetPopUp).then(res => {
        if (res.data?.success && res.data.data?.image) {
          setPopUp(res.data.data);
          setLgShow(true);
          localStorage.setItem('hasSeenPopup', 'true'); // Mark as seen
        }
      }).catch(error => {
        console.error("Error loading popup:", error);
      });
    }
  }, []); // Empty dependency array = runs only once on mount

  const [banner, setBanner] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Fetch Banner Data
  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const res = await axios.get(
          "https://api.carnivalcastle.com/v1/carnivalApi/admin/get-banners?type=bingenjoy"
        );
        if (res.data.success && res.data.banners.length > 0) {
          setBanner(res.data.banners[0]);
        }
      } catch (err) {
        console.error("Error fetching banner:", err);
      }
    };
    fetchBanner();
  }, []);

  // Auto-slide every 4 seconds
  useEffect(() => {
    if (!banner?.desktopImages?.length) return;
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex + 1 >= banner.desktopImages.length ? 0 : prevIndex + 1
      );
    }, 3000);
    return () => clearInterval(interval);
  }, [banner]);

  if (!banner) return null;

  // Get current image
  const desktopImage1 = `https://api.carnivalcastle.com/${banner.desktopImages[currentIndex]}`;
  const mobileImage = `https://api.carnivalcastle.com/${banner.mobileImages[currentIndex]}`;

  // Manual navigation
  const prevSlide = () =>
    setCurrentIndex((prev) =>
      prev === 0 ? banner.desktopImages.length - 1 : prev - 1
    );
  const nextSlide = () =>
    setCurrentIndex((prev) =>
      prev + 1 >= banner.desktopImages.length ? 0 : prev + 1
    );


  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          BingeNJoy | Best Private Theaters for Celebrations in Hyderabad
        </title>
        <meta
          name="description"
          content="Experience the magic of celebrations at BingeNJoy Private Theatres in Hyderabad. Perfect for Birthdays, Anniversaries, Bride To Be, Surprise Parties, etc"
        />
      </Helmet>

      {isLoading == true ? (
        <>
          <div
            className="text-center"
            style={{
              backgroundColor: "var(--charcoal-black)",
              height: "100vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <div>
              <img
                src={load}
                style={{ height: "300px", color: "white" }}
              ></img>
              <h6 style={{ color: "gold" }}>Loading...</h6>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="home-page indexsix">
            <div className="main-wrapper">
              <>
                <Header />

                <div className="scrollbar">
                  <Slider {...settings}>
                    {/* Desktop images ko map karo */}
                    {banner?.desktopImages?.map((desktopImage, index) => (
                      <div key={index}>
                        <div className="mt-0">
                          {PopUp1.modalEnabled && (
                            <div style={{ backgroundColor: "#fa462af2" }} className="text-center py-2">
                              <marquee className="text-white fw-bold">
                                LAST MINUTE OFFER: {PopUp1.title}
                              </marquee>
                            </div>
                          )}
                        </div>
                        <section
                          className="banner-section d-flex align-items-center position-relative text-white overflow-hidden"
                          style={{
                            backgroundImage: `url(https://api.carnivalcastle.com/${desktopImage})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                            height: "100vh",
                            transition: "background-image 1s ease-in-out",
                          }}
                        >
                          {/* Overlay */}
                          <div
                            className="overlay position-absolute w-100 h-100"
                            style={{
                              background: "rgba(0, 0, 0, 0.4)",
                              top: 0,
                              left: 0,
                              zIndex: 1,
                            }}
                          ></div>

                          {/* Content */}
                          <div className="container position-relative h-100" style={{ zIndex: 2 }}>
                            <div className="row justify-content-center text-center text-md-start h-100">
                              <div className="col-lg-10 d-flex flex-column justify-content-center h-100">
                                <h1 className="fw-bold mb-3 animate__animated animate__fadeInDown">
                                  {banner.title}
                                </h1>
                                <p className="lead mb-4 animate__animated animate__fadeInUp">
                                  {banner.description}
                                </p>

                                <div className="banner-buttons d-flex flex-column flex-sm-row gap-3">
                                  <a
                                    href="/locations"
                                    className="btn btn-lg px-4 fw-bold btn-purple"
                                  >
                                    Book Now
                                  </a>
                                  <a
                                    href="tel:8977917555"
                                    className="btn btn-lg px-4 fw-bold btn-purple"
                                  >
                                    Book via Call
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>



                          {/* Slide Dots */}
                          <div
                            className="position-absolute w-100 d-flex justify-content-center gap-2"
                            style={{ bottom: "25px", zIndex: 3 }}
                          >
                            {banner.desktopImages.map((_, index) => (
                              <div
                                key={index}
                                onClick={() => setCurrentIndex(index)}
                                style={{
                                  width: currentIndex === index ? "12px" : "8px",
                                  height: currentIndex === index ? "12px" : "8px",
                                  borderRadius: "50%",
                                  background:
                                    currentIndex === index
                                      ? "#fff"
                                      : "rgba(255,255,255,0.5)",
                                  cursor: "pointer",
                                  transition: "all 0.3s ease",
                                }}
                              ></div>
                            ))}
                          </div>

                          {/* Mobile background override */}
                          <style>
                            {`
          @media (max-width: 768px) {
            .banner-section {
              background-image: url(${mobileImage}) !important;
            }
          }
        `}
                          </style>
                        </section>


                        {/* Floating Cards Section */}
                        <div
                          className="container position-relative mb-5"
                          style={{ marginTop: "-80px", zIndex: 3 }}
                        >
                          <div className="row g-4 justify-content-center">
                            {/* Birthday Celebrations */}
                            <div className="col-md-4" onClick={() => navigate('/locations')}>
                              <div className="card shadow border-0 h-100 p-3 card123">
                                <div className="d-flex align-items-center mb-2">
                                  <i className="fas fa-film text-purple me-2 fs-4"></i>
                                  <h5 className="mb-0 text-purple">Birthday Celebrations</h5>
                                </div>
                                <p className="text-muted small mt-2">
                                  Turn your birthday into a cinematic event! Celebrate with your favorite
                                  movie, personalized decorations, and a private theatre experience that
                                  makes you feel like the star of the show. Perfect for intimate gatherings
                                  or grand celebrations.
                                </p>
                              </div>
                            </div>

                            {/* Proposals */}
                            <div className="col-md-4" onClick={() => navigate('/locations')}>
                              <div className="card shadow border-0 h-100 p-3 card123">
                                <div className="d-flex align-items-center mb-2">
                                  <i className="fas fa-heart text-purple me-2 fs-4"></i>
                                  <h5 className="mb-0 text-purple">Proposals</h5>
                                </div>
                                <p className="text-muted small mt-2">
                                  Make your special moment unforgettable with a cinematic proposal.
                                  Surprise your loved one with a private screening, a custom video,
                                  and a romantic ambience that sets the perfect stage to say “Yes!”
                                </p>
                              </div>
                            </div>

                            {/* Special Celebrations */}
                            <div className="col-md-4" onClick={() => navigate('/locations')}>
                              <div className="card shadow border-0 h-100 p-3 card123">
                                <div className="d-flex align-items-center mb-2">
                                  <i className="fas fa-star text-purple me-2 fs-4"></i>
                                  <h5 className="mb-0 text-purple">Special Celebrations</h5>
                                </div>
                                <p className="text-muted small mt-2">
                                  Celebrate life’s biggest milestones in style — anniversaries, surprises,
                                  or achievements. Create magical memories with cinematic visuals, mood
                                  lighting, and luxurious comfort that elevate every celebration.
                                </p>
                              </div>
                            </div>

                            {/* Hover CSS */}
                            <style>{`
      .card123 {
        border-radius: 12px;
        transition: all 0.3s ease;
        cursor: pointer;
      }

      .card123:hover {
        transform: translateY(-10px) scale(1.03);
        box-shadow: 0 12px 25px rgba(0, 0, 0, 0.25);
        background: linear-gradient(135deg, #7b2cbf, #9d4dff);
        color: #fff;
      }

      .card123:hover h5,
      .card123:hover p,
      .card123:hover i {
        color: #fff !important;
      }

      .card123 i {
        transition: transform 0.3s ease, color 0.3s ease;
      }

      .card123:hover i {
        transform: rotate(10deg) scale(1.2);
      }
    `}</style>
                          </div>
                        </div>




                      </div>
                    ))}
                  </Slider>
                </div>



                {testimonials.length > 0 && (
                  <section
                    className="py-5 position-relative text-dark"
                    style={{ backgroundColor: "#fff", overflowX: "hidden" }}
                  >
                    <Container fluid="lg">
                      <Row className="flex-column align-items-center text-center">
                        {/* TITLE */}
                        <Col xs={12} className="mb-4">
                          <h2 className="fw-bold mt-3 dark-text">Testimonials</h2>
                          <p className="light-text fs-6">
                            Real stories. Real celebrations. Real magic at Binge N Joy.
                          </p>
                        </Col>

                        {/* SLIDER */}
                        <Col xs={12} className="d-flex justify-content-center position-relative">
                          <div
                            id="testimonial3DCarousel"
                            className="carousel slide carousel-fade position-relative"
                            data-bs-ride="false"
                          >
                            <div className="carousel-inner w-100">
                              {testimonials.map((item, index) => {
                                const prevIndex = index === 0 ? testimonials.length - 1 : index - 1;
                                const nextIndex = index === testimonials.length - 1 ? 0 : index + 1;

                                return (
                                  <div
                                    key={index}
                                    className={`carousel-item ${index === 0 ? "active" : ""}`}
                                  >
                                    <div className="d-flex justify-content-center align-items-center gap-3 px-3">
                                      {/* LEFT SMALL CARD - PREVIOUS TESTIMONIAL */}
                                      <div
                                        className="side-video small-card shadow rounded overflow-hidden d-none d-md-block"
                                        style={{
                                          width: "150px",
                                          height: "200px",
                                          backgroundImage: `url(${testimonials[prevIndex]?.profileImage
                                            ? testimonials[prevIndex]?.profileImage.replace(/\\/g, "/").startsWith("uploads/")
                                              ? `https://api.carnivalcastle.com/${testimonials[prevIndex]?.profileImage.replace(/\\/g, "/")}`
                                              : testimonials[prevIndex]?.profileImage
                                            : ""
                                            })`,

                                          backgroundSize: "cover",
                                          backgroundPosition: "center",
                                          opacity: "0.7",
                                        }}
                                      >
                                        <div className="w-100 h-100 d-flex align-items-end justify-content-center p-2">
                                          <div className="bg-dark bg-opacity-75 text-white px-2 py-1 rounded small">
                                            {testimonials[prevIndex]?.name}
                                          </div>
                                        </div>
                                      </div>

                                      {/* MAIN VIDEO - CURRENT TESTIMONIAL */}
                                      <div
                                        className="main-video-card position-relative shadow rounded overflow-hidden"
                                        style={{ width: "400px" }}
                                      >
                                        <iframe
                                          width="100%"
                                          height="300"
                                          src={`https://www.youtube.com/embed/${item.videoId}?autoplay=1&mute=1&loop=0`}
                                          title={item.name}
                                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                          allowFullScreen
                                        ></iframe>

                                        <div className="label-card mt-3">
                                          <div className="bg-white px-3 py-2 rounded-4 shadow-sm text-center">
                                            <strong className="dark-text">{item.name}</strong>
                                            <br />
                                            <small className="text-dark">{item.role}</small>
                                          </div>
                                        </div>
                                      </div>

                                      {/* RIGHT SMALL CARD - NEXT TESTIMONIAL */}
                                      <div
                                        className="side-video small-card shadow rounded overflow-hidden d-none d-md-block"
                                        style={{
                                          width: "150px",
                                          height: "200px",
                                          backgroundImage: `url(${testimonials[nextIndex]?.profileImage?.replace(/\\/g, "/").startsWith("uploads/")
                                              ? `https://api.carnivalcastle.com/${testimonials[nextIndex]?.profileImage.replace(/\\/g, "/")}`
                                              : testimonials[nextIndex]?.profileImage
                                            })`,

                                          backgroundSize: "cover",
                                          backgroundPosition: "center",
                                          opacity: "0.7",
                                        }}
                                      >
                                        <div className="w-100 h-100 d-flex align-items-end justify-content-center p-2">
                                          <div className="bg-dark bg-opacity-75 text-white px-2 py-1 rounded small">
                                            {testimonials[nextIndex]?.name}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>

                            {/* Desktop Indicators - Top position */}
                            <div className="carousel-indicators position-relative mt-4 d-none d-md-flex justify-content-center">
                              {testimonials.map((_, index) => (
                                <button
                                  key={index}
                                  type="button"
                                  data-bs-target="#testimonial3DCarousel"
                                  data-bs-slide-to={index}
                                  className={index === 0 ? "active" : ""}
                                  aria-current={index === 0 ? "true" : "false"}
                                  aria-label={`Slide ${index + 1}`}
                                ></button>
                              ))}
                            </div>

                            {/* Mobile Navigation Buttons - Bottom position */}
                            <div className="d-md-none mobile-navigation-buttons position-absolute w-100 d-flex justify-content-center align-items-center gap-3">
                              <button
                                className="mobile-nav-btn mobile-prev-btn bg-dark text-white border-0 rounded-circle d-flex align-items-center justify-content-center"
                                type="button"
                                data-bs-target="#testimonial3DCarousel"
                                data-bs-slide="prev"
                                aria-label="Previous testimonial"
                              >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                  <path d="M15 18l-6-6 6-6" />
                                </svg>
                              </button>

                              {/* Mobile Slide Indicators */}
                              <div className="d-flex align-items-center gap-2">
                                {testimonials.map((_, index) => (
                                  <button
                                    key={index}
                                    type="button"
                                    data-bs-target="#testimonial3DCarousel"
                                    data-bs-slide-to={index}
                                    className={`mobile-indicator-btn ${index === 0 ? "active" : ""}`}
                                    aria-label={`Go to slide ${index + 1}`}
                                  ></button>
                                ))}
                              </div>

                              <button
                                className="mobile-nav-btn mobile-next-btn bg-dark text-white border-0 rounded-circle d-flex align-items-center justify-content-center"
                                type="button"
                                data-bs-target="#testimonial3DCarousel"
                                data-bs-slide="next"
                                aria-label="Next testimonial"
                              >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                  <path d="M9 18l6-6-6-6" />
                                </svg>
                              </button>
                            </div>

                            {/* Desktop Controls */}
                            <button
                              className="carousel-control-prev d-none d-md-flex"
                              type="button"
                              data-bs-target="#testimonial3DCarousel"
                              data-bs-slide="prev"
                            >
                              <span
                                className="carousel-control-prev-icon bg-dark rounded-circle p-2"
                                aria-hidden="true"
                              ></span>
                              <span className="visually-hidden">Previous</span>
                            </button>
                            <button
                              className="carousel-control-next d-none d-md-flex"
                              type="button"
                              data-bs-target="#testimonial3DCarousel"
                              data-bs-slide="next"
                            >
                              <span
                                className="carousel-control-next-icon bg-dark rounded-circle p-2"
                                aria-hidden="true"
                              ></span>
                              <span className="visually-hidden">Next</span>
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </Container>

                    {/* CSS */}
                    <style jsx>{`
      #testimonial3DCarousel {
        margin: 0 auto;
        max-width: 900px;
        width: 100%;
        position: relative;
        padding-bottom: 80px; /* Space for mobile navigation */
      }

      .carousel-inner {
        text-align: center;
      }

      .carousel-item {
        transition: transform 0.6s ease-in-out;
      }

      .carousel-item.active .main-video-card {
        transform: scale(1.05);
        transition: transform 0.6s ease;
      }

      .carousel-item.active .side-video {
        opacity: 1 !important;
        transform: scale(0.9);
        transition: all 0.4s ease;
      }

      .main-video-card {
        transition: all 0.6s ease;
        z-index: 2;
        flex-shrink: 0;
      }

      .side-video {
        transition: all 0.4s ease;
        position: relative;
        cursor: pointer;
      }

      .side-video:hover {
        opacity: 0.9 !important;
        transform: scale(0.95);
      }

      /* Desktop Indicators */
      .carousel-indicators.position-relative {
        margin-top: 2rem;
      }

      .carousel-indicators.position-relative button {
        background-color: #dee2e6;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        border: none;
        margin: 0 5px;
        transition: all 0.3s ease;
      }

      .carousel-indicators.position-relative .active {
        background-color: #7b2cbf;
        width: 25px;
        border-radius: 10px;
      }

      /* Mobile Navigation Buttons */
      .mobile-navigation-buttons {
        bottom: 10px;
        left: 0;
        right: 0;
        padding: 0 20px;
        z-index: 10;
      }

      .mobile-nav-btn {
        width: 44px;
        height: 44px;
        background-color: #7b2cbf !important;
        border: none;
        cursor: pointer;
        transition: all 0.3s ease;
        flex-shrink: 0;
      }

      .mobile-nav-btn:hover {
        background-color: #6a1b9a !important;
        transform: scale(1.1);
      }

      .mobile-nav-btn:active {
        transform: scale(0.95);
      }

      .mobile-nav-btn svg {
        color: white;
      }

      /* Mobile Slide Indicators */
      .mobile-indicator-btn {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        border: none;
        background-color: #dee2e6;
        cursor: pointer;
        transition: all 0.3s ease;
        margin: 0 2px;
      }

      .mobile-indicator-btn.active {
        background-color: #7b2cbf;
        width: 25px;
        border-radius: 10px;
      }

      .mobile-indicator-btn:hover {
        background-color: #7b2cbf;
        transform: scale(1.2);
      }

      .carousel-control-prev,
      .carousel-control-next {
        width: auto;
        opacity: 1;
      }

      .carousel-control-prev {
        left: -50px;
      }

      .carousel-control-next {
        right: -50px;
      }

      /* Mobile-specific styles */
      @media (max-width: 1200px) {
        .carousel-control-prev {
          left: -30px;
        }
        .carousel-control-next {
          right: -30px;
        }
      }

      @media (max-width: 992px) {
        .main-video-card {
          width: 100% !important;
          max-width: 350px;
        }

        .side-video {
          display: none !important;
        }

        .carousel-control-prev {
          left: -20px;
        }
        .carousel-control-next {
          right: -20px;
        }

        #testimonial3DCarousel {
          padding-bottom: 70px;
        }

        .mobile-navigation-buttons {
          bottom: 5px;
        }
      }

      @media (max-width: 768px) {
        .mobile-nav-btn {
          width: 40px;
          height: 40px;
        }

        .mobile-indicator-btn {
          width: 8px;
          height: 8px;
        }

        .mobile-indicator-btn.active {
          width: 20px;
        }
      }

      @media (max-width: 576px) {
        .main-video-card iframe {
          height: 220px;
        }
        
        .carousel-control-prev,
        .carousel-control-next {
          display: none;
        }

        #testimonial3DCarousel {
          padding-bottom: 60px;
        }

        .mobile-navigation-buttons {
          bottom: 0;
          padding: 0 15px;
        }

        .mobile-nav-btn {
          width: 36px;
          height: 36px;
        }

        .mobile-indicator-btn {
          width: 7px;
          height: 7px;
        }

        .mobile-indicator-btn.active {
          width: 18px;
        }
      }

      @media (max-width: 400px) {
        .mobile-nav-btn {
          width: 32px;
          height: 32px;
        }

        .mobile-indicator-btn {
          width: 6px;
          height: 6px;
          margin: 0 1px;
        }

        .mobile-indicator-btn.active {
          width: 16px;
        }

        #testimonial3DCarousel {
          padding-bottom: 50px;
        }

        .mobile-navigation-buttons {
          gap: 2px;
        }
      }
    `}</style>
                  </section>
                )}




                {/* <section className="pt-5 bg-white" >
                  <div className="container-fluid text-center pt-2 gradientright">
                    <h2 className="fw-bold mb-5 dark-text">Our Branches</h2>

                    <div className="row justify-content-center">
                      {addresses.map((addr, idx) => (
                        <div className="col-md-6 col-lg-5 mb-4" key={idx}>
                          <div
                            className="p-4 shadow-lg h-100"
                            style={{
                              backgroundColor: "#fff",
                              borderRadius: "2rem",
                              transition: "0.3s",
                            }}
                          >
                            <h4 className="fw-bold text-center mb-3" style={{ color: "#5b179b" }}>
                              {addr.name}
                            </h4>
                            <p
                              className="text-muted mb-3 text-center"
                              style={{ fontStyle: "italic", fontSize: "0.95rem" }}
                            >
                              {addr.addressLine1}, {addr.addressLine2}
                            </p>

                            <div className="text-center">
                              <a
                                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                                  `${addr.addressLine1}, ${addr.addressLine2}`
                                )}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-decoration-none fw-semibold"
                                style={{ color: "#6d28d9" }}
                              >
                                <i className="bi bi-geo-alt-fill me-2 light-text fs-xl"></i>See on map
                              </a>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                
                  <style jsx>{`
        .text-purple {
          color: #5b179b;
        }
      `}</style>
                </section> */}

                <TheaterDetails />

                {/*
                <section className="py-5 bg-light">
                  <div className="container">
                    <div className="text-center mb-5">
                      <h2 className="display-5 fw-bold dark-text">Our Packages</h2>
                      <p className="fs-5 light-text">
                        <i>Choose Wisely</i>
                      </p>
                    </div>

                   
                    <div className="row g-4 justify-content-center d-none d-md-flex">
                      {packages.map((pkg) => (
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-10" key={pkg.id}>
                          <div className="card border-0 shadow rounded-4 h-100 text-center gradient45 position-relative">
                            <div className="card-body d-flex flex-column p-4">
                              
                              <div className="mb-3">
                                <h4 className="fw-bold mb-1">{pkg.title}</h4>
                                <p
                                  className="text-muted mb-0"
                                  style={{ fontStyle: "italic", fontSize: "14px" }}
                                >
                                  {pkg.subtitle}
                                </p>
                              </div>

                           
                              <ul className="list-unstyled text-start flex-grow-1 mb-1 px-2">
                                {Object.keys(pkg.detailedFeatures).map((feature, index) => (
                                  <li key={index} className="d-flex align-items-center mb-2">
                                    <span
                                      className={`me-2 fw-bold ${pkg.detailedFeatures[feature] ? "text-success" : "text-danger"
                                        }`}
                                    >
                                      {pkg.detailedFeatures[feature] ? "✅" : "❌"}
                                    </span>
                                    <span className="text-dark">{feature}</span>
                                  </li>
                                ))}
                              </ul>

                       
                              {pkg?.price ? (
                                <p className="fw-semibold mb-4 mt-auto">
                                  Starts from ₹{pkg.price}
                                </p>
                              ) : null}

                         
                              <button
                                className="btn text-white w-100"
                                style={{ backgroundColor: "#a259ff", borderRadius: "10px" }}
                                onClick={() => navigateTheater("/locations")}
                              >
                                {pkg.buttonText}
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                 
                    <div
                      id="packagesCarousel"
                      className="carousel slide d-block d-md-none"
                      data-bs-ride="carousel"
                      data-bs-interval="3000"
                      data-bs-wrap="true"
                      data-bs-pause="false"
                    >
                    
                      <div className="carousel-indicators">
                        {packages.map((_, index) => (
                          <button
                            key={index}
                            type="button"
                            data-bs-target="#packagesCarousel"
                            data-bs-slide-to={index}
                            className={index === 0 ? "active" : ""}
                            aria-current={index === 0 ? "true" : "false"}
                            aria-label={`Slide ${index + 1}`}
                          ></button>
                        ))}
                      </div>

                  
                      <div className="carousel-inner">
                        {packages.map((pkg, index) => (
                          <div
                            className={`carousel-item ${index === 0 ? "active" : ""}`}
                            key={pkg.id}
                          >
                            <div className="d-flex justify-content-center">
                              <div className="col-10">
                                <div className="card border-0 shadow rounded-4 text-center gradient45">
                                  <div className="card-body d-flex flex-column p-4">
                                   
                                    <div className="mb-3">
                                      <h4 className="fw-bold mb-1">{pkg.title}</h4>
                                      <p
                                        className="text-muted mb-0"
                                        style={{ fontStyle: "italic", fontSize: "14px" }}
                                      >
                                        {pkg.subtitle}
                                      </p>
                                    </div>

                                 
                                    <ul className="list-unstyled text-start flex-grow-1 mb-1 px-2">
                                      {Object.keys(pkg.detailedFeatures).map((feature, idx) => (
                                        <li key={idx} className="d-flex align-items-center mb-2">
                                          <span
                                            className={`me-2 fw-bold ${pkg.detailedFeatures[feature] ? "text-success" : "text-danger"
                                              }`}
                                          >
                                            {pkg.detailedFeatures[feature] ? "✅" : "❌"}
                                          </span>
                                          <span className="text-dark">{feature}</span>
                                        </li>
                                      ))}
                                    </ul>

                                   
                                    {pkg?.price ? (
                                      <p className="fw-semibold mb-4 mt-auto">
                                        Starts from ₹{pkg.price}
                                      </p>
                                    ) : null}

                                   
                                    <button
                                      className="btn text-white w-100"
                                      style={{ backgroundColor: "#a259ff", borderRadius: "10px" }}
                                      onClick={() => navigateTheater("/locations")}
                                    >
                                      {pkg.buttonText}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>

                     
                      <button
                        className="carousel-control-prev"
                        type="button"
                        data-bs-target="#packagesCarousel"
                        data-bs-slide="prev"
                      >
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                      </button>
                      <button
                        className="carousel-control-next"
                        type="button"
                        data-bs-target="#packagesCarousel"
                        data-bs-slide="next"
                      >
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                      </button>
                    </div>
                  </div>
                </section>
                */}



                <section className="occasions-section py-5 text-dark" style={{ backgroundColor: "#fff" }}>
                  <div className="container">
                    <h2 className="text-center mb-5 light-text">
                      What Can You Celebrate at Binge N Joy?
                    </h2>

                    {(() => {
                      const modifiedOccasions = occasions.map((occasion) => {
                        let description = "";
                        switch (occasion.name) {
                          case "Anniversary":
                            description =
                              "Celebrate your love and commitment in a private, luxurious theatre at Binge N Joy. Enjoy a personalized ambiance, delicious food, and exceptional picture quality.";
                            break;
                          case "Bride To Be":
                            description =
                              "Celebrate your upcoming wedding with a special private screening. Enjoy a memorable day filled with personalized decor, scrumptious food, and a luxurious theatre experience.";
                            break;
                          case "Groom To Be":
                            description =
                              "Make the groom’s last night as a bachelor memorable with a private screening and special services. Enjoy delicious food, exceptional sound, and an intimate theatre experience.";
                            break;
                          case "Dad To Be":
                            description =
                              "Celebrate the soon-to-be father in a private, luxurious setting with custom decor and exceptional service. Enjoy great food, a perfect movie, and a memorable experience.";
                            break;
                          case "Mom To Be":
                            description =
                              "Celebrate the expecting mother in a private theatre with amazing decor and personalized services. Enjoy a relaxing, unforgettable experience with great food and movies.";
                            break;
                          case "Love Proposal":
                            description =
                              "Plan the perfect surprise proposal at Binge N Joy Private Theatres. With a magical atmosphere, your proposal will be an unforgettable moment, complete with beautiful decor and food.";
                            break;
                          case "Marriage Proposal":
                            description =
                              "Propose in the most romantic and unforgettable way at Binge N Joy. Enjoy a private theatre with personalized decor, delicious food, and everything you need for the perfect proposal.";
                            break;
                          case "Farewell":
                            description =
                              "Bid farewell in style at Binge N Joy Private Theatres. Celebrate the memories with a private screening, delicious food, and the perfect ambiance for your farewell.";
                            break;
                          case "Bon voyage":
                            description =
                              "Send off a loved one with a special farewell event at Binge N Joy Private Theatres. Enjoy a private screening with gourmet food and personalized decor for the perfect bon voyage.";
                            break;
                          default:
                            description =
                              "Binge N Joy Private Theatres is the perfect place to celebrate any special occasion. Enjoy an intimate and luxurious setting with exceptional picture and sound quality, delicious food, and attentive staff.";
                            break;
                        }

                        return {
                          ...occasion,
                          description: description,
                          name: occasion.name === "Carnival Castle" ? "Binge N Joy" : occasion.name,
                        };
                      });

                      // Detect device width
                      const screenWidth = window.innerWidth;
                      let groupSize = 3;
                      if (screenWidth < 768) groupSize = 1;
                      else if (screenWidth < 992) groupSize = 2;

                      // Group data for carousel slides
                      const chunkArray = (arr, size) =>
                        arr.reduce(
                          (acc, _, i) => (i % size === 0 ? [...acc, arr.slice(i, i + size)] : acc),
                          []
                        );

                      const slides = chunkArray(modifiedOccasions, groupSize);

                      return (
                        <div
                          id="occasionCarousel"
                          className="carousel slide"
                          data-bs-ride="carousel"
                          data-bs-interval="5000"
                          data-bs-pause="hover"
                        >
                          <div className="carousel-inner">
                            {slides.map((group, slideIndex) => (
                              <div className={`carousel-item ${slideIndex === 0 ? "active" : ""}`} key={slideIndex}>
                                <div className="row g-4 justify-content-center">
                                  {group.map((occasion, index) => (
                                    <div className="col-12 col-md-6 col-lg-4 d-flex justify-content-center" key={index}>
                                      <div className="card h-100 text-center bg-light rounded-4 gradient45 p-3 w-100">
                                        <div className="card-body d-flex flex-column align-items-center">
                                          <img
                                            src={URLS.Base + occasion.image}
                                            alt={occasion.name}
                                            className="rounded-circle mb-3"
                                            style={{
                                              height: "100px",
                                              width: "100px",
                                              objectFit: "cover",
                                              border: "2px solid #E9BE5F",
                                            }}
                                          />
                                          <h5 className="card-title" style={{ color: "#681DC0" }}>
                                            {occasion.name}
                                          </h5>
                                          <p className="card-text small">{occasion.description}</p>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            ))}
                          </div>

                          {/* Carousel Controls */}
                          <button
                            className="carousel-control-prev"
                            type="button"
                            data-bs-target="#occasionCarousel"
                            data-bs-slide="prev"
                          >
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                          </button>
                          <button
                            className="carousel-control-next"
                            type="button"
                            data-bs-target="#occasionCarousel"
                            data-bs-slide="next"
                          >
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                          </button>

                          {/* Proceed Button */}
                          <div className="text-center mt-5">
                            <button
                              className="btn px-5 py-2 rounded-3 fw-bold dark-back text-light"
                              style={{ width: "80%", maxWidth: "500px" }}
                              onClick={() => navigate('/locations')}
                            >
                              Proceed <i className="bi bi-arrow-right ms-2"></i>
                            </button>
                          </div>
                        </div>
                      );
                    })()}
                  </div>
                </section>

                <section className="services-section py-4 bg-white text-dark">
                  <div className="container">
                    <h2 className="text-center mb-4 fw-bold dark-text">Experience Our Services</h2>

                    <div className="row g-3 justify-content-center">
                      {/* Common card style */}
                      {[
                        { img: beverages, title: "Food & Beverages", text: "Choose the perfect food combo for your celebration.", link: "/Food" },
                        { img: screening, title: "Screening", text: "Bring your OTT accounts and relive the theatre magic!" },
                        { img: cake4, title: "Cakes", text: "Choose the perfect cake for your celebration from our selection.", link: "/cakes" },
                        { img: roses, title: "Bouquets", text: "Add a beautiful rose bouquet to enhance your celebration." }
                      ].map((service, idx) => (
                        <div key={idx} className="col-6 col-md-3">
                          <div className="service-card text-center rounded-4 shadow-sm p-3 h-100">
                            <img
                              src={service.img}
                              alt={service.title}
                              className="rounded-circle mb-2"
                              style={{
                                height: "80px",
                                width: "80px",
                                objectFit: "cover",
                                border: "2px solid #E9BE5F",
                              }}
                            />
                            <h6 className="fw-semibold mb-1 light-text">{service.title}</h6>
                            <p className="text-muted small mb-2" style={{ minHeight: "40px" }}>
                              {service.text}
                            </p>
                            {service.link && (
                              <a href={service.link} className="text-decoration-none small fw-semibold text-purple">
                                View more <i className="fas fa-arrow-right"></i>
                              </a>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Inline styles */}
                  <style jsx>{`
    .service-card {
     background: linear-gradient(45deg, #FFFAFB, #C69FF4)!important;
      transition: all 0.3s ease;
    }
    .service-card:hover {
      transform: translateY(-3px);
      box-shadow: 0 4px 12px rgba(91, 23, 155, 0.2);
    }
    .text-purple {
      color: #5b179b;
    }
    @media (max-width: 576px) {
      .service-card img {
        height: 65px;
        width: 65px;
      }
      .service-card p {
        font-size: 0.75rem;
      }
    }
  `}</style>
                </section>


                <CouponSection />



                {/* WHY US Section */}
                <section className="py-5 lighter-back">
                  <Container>
                    <div className="position-relative">
                      <Carousel
                        activeIndex={index}
                        onSelect={handleSelect}
                        controls={false}
                        indicators={false}
                        fade={false}
                        pause={false} // allows auto + manual without stopping on hover
                        touch={true}
                      >
                        {whyUsSlides.map((slide, idx) => (
                          <Carousel.Item key={idx}>
                            <Row className="align-items-center g-4 flex-column flex-md-row text-center text-md-start">
                              {/* Left - Image */}
                              <Col md={6}>
                                <img
                                  src={slide.image}
                                  alt="Highlight"
                                  className="img-fluid rounded-4 shadow w-100"
                                  style={{ maxHeight: "420px", objectFit: "cover" }}
                                />
                              </Col>

                              {/* Right - Text */}
                              <Col md={6}>
                                <div className="ps-md-4 mt-4 mt-md-0">
                                  <h2 className="mb-3" style={{ color: "#681DC0" }}>{slide.title}</h2>
                                  <h6 className="fw-semibold mb-4">{slide.subtitle}</h6>
                                  <ul className="list-unstyled">
                                    {slide.points.map((point, i) => (
                                      <li
                                        key={i}
                                        className="mb-2 d-flex align-items-start justify-content-center justify-content-md-start"
                                      >
                                        <i className="fas fa-check-circle text-warning me-2 mt-1"></i>
                                        <span className="text-dark">{point}</span>
                                      </li>
                                    ))}
                                  </ul>
                                  <div className="mt-4 text-end">
                                    <Button
                                      onClick={() => window.location.href = "/locations"}
                                      className="rounded-3 px-4 py-2 fw-semibold dark-back"
                                    >
                                      <i className="fas fa-ticket-alt me-2" />
                                      Book Now
                                    </Button>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </Carousel.Item>
                        ))}
                      </Carousel>

                      {/* Bottom Indicators */}
                      <div className="d-flex justify-content-center mt-4">
                        {whyUsSlides.map((_, i) => (
                          <button
                            key={i}
                            onClick={() => handleSelect(i)}
                            className={`carousel-indicator mx-1 rounded-circle ${index === i ? 'bg-warning' : 'bg-secondary'}`}
                            style={{
                              width: "12px",
                              height: "12px",
                              border: "none",
                              transition: "0.3s",
                            }}
                          ></button>
                        ))}
                      </div>
                    </div>
                  </Container>

                  <style jsx>{`
        .carousel-indicator {
          opacity: 0.6;
          cursor: pointer;
        }
        .carousel-indicator.bg-primary {
          opacity: 1;
        }
      `}</style>
                </section>


                <section className="py-5 bg-white position-relative">
                  <Container>
                    <h2 className="text-center fw-bold mb-3 dark-text">
                      What Our Customers Say
                    </h2>
                    <p className="text-center fs-5 light-text">
                      Real stories. Real celebrations. Real magic at Binge N Joy.
                    </p>

                    {(() => {
                      const screenWidth = window.innerWidth;
                      let groupSize = 3;
                      if (screenWidth < 768) groupSize = 1;
                      else if (screenWidth < 992) groupSize = 2;

                      const chunkArray = (arr, size) =>
                        arr.reduce(
                          (acc, _, i) => (i % size === 0 ? [...acc, arr.slice(i, i + size)] : acc),
                          []
                        );

                      const slides = chunkArray(testimonials, groupSize);

                      return (
                        <Carousel
                          controls={false}
                          indicators={false}
                          interval={4000}
                          pause={false}
                          fade={false}
                          wrap
                        >
                          {slides.map((group, idx) => (
                            <Carousel.Item key={idx}>
                              <Row className="g-4 justify-content-center">
                                {group.map((review, index) => (
                                  <Col lg={4} md={6} sm={12} key={index}>
                                    <div
                                      className="review-card position-relative rounded-4 overflow-hidden shadow mb-4"
                                      style={{
                                        height: "340px",
                                        maxHeight: "360px",
                                      }}
                                    >
                                      {/* Background Image */}
                                      <img
                                        src={
                                          review.image
                                            ? review.image.startsWith("uploads")
                                              ? `https://api.carnivalcastle.com/${review.image.replace(/\\/g, "/")}`
                                              : review.image
                                            : "https://via.placeholder.com/400x300" // fallback
                                        }
                                        alt="Review background"
                                        className="w-100 h-100 object-fit-cover"
                                        style={{
                                          filter: "brightness(70%)",
                                        }}
                                      />

                                      {/* Overlay Card */}
                                      <div
                                        className="position-absolute bottom-0 start-50 translate-middle-x p-3 rounded-top-4"
                                        style={{
                                          width: "92%",
                                          backgroundColor: "#fff",
                                          backdropFilter: "blur(5px)",
                                          minHeight: "43%",
                                        }}
                                      >
                                        <div className="d-flex align-items-center mb-2">
                                          <img
                                            src={
                                              review.profileImage
                                                ? review.profileImage.startsWith("uploads")
                                                  ? `https://api.carnivalcastle.com/${review.profileImage.replace(/\\/g, "/")}`
                                                  : review.profileImage
                                                : "https://via.placeholder.com/60" // fallback
                                            }
                                            alt="avatar"
                                            className="rounded-circle me-3 border border-light"
                                            width="55"
                                            height="55"
                                            style={{ objectFit: "cover" }}
                                          />
                                          <div>
                                            <h6 className="mb-0 fw-bold text-dark">{review.name}</h6>
                                            <small className="text-muted">{review.location}</small>
                                          </div>
                                        </div>

                                        <div className="text-warning mb-1 fs-6">
                                          {"★".repeat(review.rating)}
                                          {"☆".repeat(5 - review.rating)}
                                        </div>

                                        <p
                                          className="mb-1 text-dark"
                                          style={{
                                            fontSize: "0.85rem",
                                            lineHeight: "1.3rem",
                                            maxHeight: "65px",
                                            overflow: "hidden",
                                          }}
                                        >
                                          {review.description}
                                        </p>

                                        {review.occasion && (
                                          <p
                                            className="mb-0 text-dark"
                                            style={{ fontSize: "0.8rem" }}
                                          >
                                            <strong>Occasion:</strong> {review.occasion}
                                          </p>
                                        )}
                                      </div>
                                    </div>
                                  </Col>
                                ))}
                              </Row>
                            </Carousel.Item>
                          ))}
                        </Carousel>
                      );
                    })()}

                    <style jsx>{`
      .carousel-indicators {
        display: none !important;
      }

      .review-card {
        transition: transform 0.4s ease, box-shadow 0.4s ease;
      }

      .review-card:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
      }

      @media (max-width: 992px) {
        .review-card {
          height: 320px !important;
        }
      }

      @media (max-width: 768px) {
        .review-card {
          height: 300px !important;
        }
        .review-card img {
          object-position: center;
        }
        .review-card .p-3 {
          padding: 1rem !important;
        }
      }

      @media (max-width: 576px) {
        .review-card {
          height: 280px !important;
        }
        .review-card img {
          filter: brightness(75%);
        }
      }
    `}</style>
                  </Container>
                </section>






                {/* Gallery */}
                <section className="pb-3 lighter-back">
                  <div className="container-md">
                    <div className="section-wraper row d-flex align-items-center">
                      <div className="col-md-12 section-header mb-0 mt-3">
                        <h2 className="text-center fw-bold mb-3 dark-text">Gallery</h2>
                        <p className="text-center mb-5 fs-5 light-text">
                          See how our guests made memories at Binge N Joy.
                        </p>
                      </div>

                      <div className="row justify-content-center">
                        <div className="container-md">
                          <div>
                            <Galleria
                              ref={galleria}
                              value={images}
                              numVisible={7}
                              style={{ maxWidth: "850px" }}
                              activeIndex={activeIndex}
                              onItemChange={(e) => setActiveIndex(e.index)}
                              circular
                              fullScreen
                              showItemNavigators
                              showThumbnails={false}
                              item={itemTemplate}
                              thumbnail={thumbnailTemplate}
                            />

                            {/* Thumbnails Grid */}
                            <div>
                              <div className="row mb-2">
                                {displayImages.map((image, index) => (
                                  <div
                                    className="col-lg-4 col-md-6 col-sm-12 mt-3 mb-4"
                                    key={index}
                                  >
                                    <div
                                      className="zoom-container position-relative"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        setActiveIndex(index);
                                        galleria.current.show();
                                      }}
                                    >
                                      <img
                                        src={URLS.Base + image.image}
                                        alt={image.alt}
                                        style={{
                                          width: "100%",
                                          height: "300px",
                                          objectFit: "cover",
                                          border: "1px solid #F5E7B6",
                                          borderRadius: "8px",
                                        }}
                                      />
                                      <span className="zoom-icon position-absolute top-50 start-50 translate-middle text-white fs-3 opacity-75">
                                        <i className="fas fa-search-plus"></i>
                                      </span>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Buttons */}
                      <div className="col-md-12 text-center mt-3 mb-4">
                        <button
                          onClick={toggleShowAll}
                          className="btn dark-back fw-bold me-2  text-white"
                        >
                          {showAll ? "Show Less" : "Show All"}
                        </button>

                        <a href="/gallery" className="btn btn-primary fw-bold dark-back">
                          View Gallery <i className="bi bi-arrow-right ms-2"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </section>



                <section className="py-5 bg-white">
                  <div className="container">
                    <div className="row justify-content-between align-items-center rounded-4 p-4 shadow lighter-back">
                      {/* Text Column */}
                      <div className="col-12 col-md-8 mb-3 mb-md-0">
                        <h4 className="fw-bold dark-text mb-2">Follow Our Journey on Instagram</h4>
                        <p className="text-muted m-0">Get inspired by our latest creations and behind-the-scenes moments.</p>
                      </div>

                      {/* Button Column */}
                      <div className="col-12 col-md-4 text-md-end">
                        <a
                          href="https://www.instagram.com/binge_n_joy_private_theatres/"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="d-inline-flex align-items-center gap-2 px-4 py-2 rounded-pill text-decoration-none fw-semibold"
                          style={{
                            background: "linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)",
                            color: "#fff",
                            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)",
                          }}
                        >
                          <i className="fab fa-instagram"></i> binge_N_joy_hyderabad
                        </a>
                      </div>
                    </div>
                  </div>
                </section>








                {/* FAQS */}
                <section className="pb-3 pb-3 bg-light">
                  <div className="container">
                    <div className="section-wraper row d-flex align-items-center">
                      <div className="row justify-content-center">
                        <div className="col-xl-6 col-lg-8">
                          <div className="section-title text-center mb-5 pt-3">
                            <h2 className="dark-text">
                              Frequently Asked Questions
                            </h2>
                          </div>
                        </div>
                      </div>
                      <div className="row justify-content-center">
                        <div className="col-md-8">
                          <Accordion defaultActiveKey="0">
                            {Faqs?.map((data, i) => {
                              // Replace "Carnival Castle" with "Binge N Joy" in the question and answer
                              let updatedQuestion = data.question?.replace(/Carnival Castle/g, "Binge N Joy");
                              let updatedAnswer = data.answer
                                ?.replace(/Carnival Castle/g, "Binge N Joy")
                                .replace(/https:\/\/carnivalcastle\.com/g, "https://bingenjoy.com")
                                .replace(/9059382797/g, "8977917555")
                                .replace(/8341428342/g, "8977917555");

                              return (
                                <Accordion.Item
                                  className="mt-3"
                                  eventKey={i.toString()}
                                  key={i}
                                  style={{ background: "white" }}
                                >
                                  <Accordion.Header>
                                    <b>
                                      {i + 1}. {updatedQuestion}
                                    </b>
                                  </Accordion.Header>
                                  <Accordion.Body>{updatedAnswer}</Accordion.Body>
                                </Accordion.Item>
                              );
                            })}
                          </Accordion>
                        </div>
                      </div>
                      {/* Book Now Button */}
                      <div className="col-md-12 text-center mt-3 mb-4">
                        <a
                          href="/locations"
                          className="btn btn-primary fw-bold dark-back"
                        >
                          Book Now

                        </a>
                      </div>
                    </div>
                  </div>
                </section>



                <section className="bg-white">
                  <div className="container-fluid text-center py-5 gradientright">
                    <h2 className="fw-bold mb-4 dark-text">Our Branches</h2>

                    <div className="d-flex flex-wrap justify-content-center gap-3">
                      {addresses.map((addr, idx) => (
                        <a
                          key={idx}
                          href={addr.addressLine2}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="branch-badge text-decoration-none fw-semibold d-inline-flex align-items-center"
                        >
                          <i className="bi bi-geo-alt-fill me-2"></i>
                          {addr.name}
                        </a>
                      ))}
                    </div>
                  </div>

                  <style jsx>{`
    .branch-badge {
      background-color: #f3e8ff;
      color: #5b179b;
      padding: 0.6rem 1.2rem;
      border-radius: 50rem;
      box-shadow: 0 3px 6px rgba(91, 23, 155, 0.2);
      transition: all 0.3s ease;
    }
    .branch-badge:hover {
      background-color: #5b179b;
      color: #fff;
      box-shadow: 0 4px 10px rgba(91, 23, 155, 0.35);
      transform: translateY(-2px);
    }
    .branch-badge i {
      font-size: 1rem;
    }
  `}</style>
                </section>





                {/* ENQUIRY */}
                {/* <section className="pt-5 pb-5 p-relative" style={{ backgroundColor: "#E9DCFF" }}>
                  <div className="p-3">
                    <div className="row justify-content-md-center">
                      <div className="pl-30">
                        <div className="row justify-content-center">
                          <div className="col-xl-6 col-lg-8"></div>
                        </div>
                      </div>
                      <div className="col-lg-6 mt-3">
                        <iframe
                          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.5504603517853!2d78.363276!3d17.4589078!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93c845555555%3A0x5a36652c3fe58487!2sBingenjoy%20-%20Private%20Theaters!5e0!3m2!1sen!2sin!4v1710247202871!5m2!1sen!2sin"
                          width="100%"
                          height={480}
                          style={{ borderRadius: "20px" }}
                          allowFullScreen=""
                          loading="lazy"
                          referrerPolicy="no-referrer-when-downgrade"
                        />
                      </div>
                      <div className="col-lg-6 mt-3">
                        <div>
                          <div className="row">
                            <div className="col-lg-6 rounded border border-2" style={{ backgroundColor: "#fff" }}>
                              <div className="contactsops" style={{ backgroundColor: "#fff" }}>
                                <img
                                  src={logo}
                                  alt="logo"
                                  style={{ height: "85px" }}
                                />
                                <p style={{ color: "black" }}>
                                  Planning a memorable celebration at Binge N Joy Private Theatre? We are ready to make your vision a reality! Whether it's a birthday, anniversary, bride to be, mom to be, groom to be, baby shower, private movie screening, special surprises or corporate event, we offer tailored packages to make each occasion special. To enquire, simply contact us to discuss your specific needs, from theme decor, food options to seating arrangements and custom add-ons.
                                </p>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="booking-form align-items-center justify-content-center">
                                <form
                                  className="mt-4 mb-3"
                                  onSubmit={(e) => {
                                    formsubmit(e);
                                  }}
                                >
                                  <>
                                    <div className="section-title text-center mb-5">
                                      <h2 className="" style={{ color: "#681DC0" }}>Enquiry Now</h2>
                                      <hr className="text-purple"></hr>
                                    </div>
                                    <div className="mb-3 input-group">
                                      <span className="input-group-text">
                                        <FontAwesomeIcon icon={faUser} />
                                      </span>
                                      <input
                                        required
                                        type="text"
                                        name="name"
                                        value={form.name}
                                        onChange={handleChange}
                                        className="form-control"
                                        placeholder="Enter Full Name*"
                                      />
                                    </div>

                                    <div className="mb-3 input-group">
                                      <span className="input-group-text">
                                        <FontAwesomeIcon icon={faPhone} />
                                      </span>
                                      <input
                                        required
                                        type="text"
                                        name="mobileNumber"
                                        onChange={handleChange}
                                        maxLength="10"
                                        minLength="10"
                                        pattern="[0-9]{10}"
                                        value={form.mobileNumber}
                                        placeholder="Enter Mobile Number*"
                                        className="form-control"
                                      />
                                    </div>

                                    <div className="mb-3 input-group">
                                      <span className="input-group-text">
                                        <FontAwesomeIcon icon={faEnvelope} />
                                      </span>
                                      <input
                                        required
                                        type="email"
                                        name="email"
                                        placeholder="Enter Email*"
                                        onChange={handleChange}
                                        value={form.email}
                                        className="form-control"
                                      />
                                    </div>

                                    <div className="mb-3 input-group">
                                      <span className="input-group-text">
                                        <FontAwesomeIcon icon={faCalendarAlt} />
                                      </span>
                                      <input
                                        required
                                        type="text"
                                        name="eventName"
                                        placeholder="Enter Event Name*"
                                        onChange={handleChange}
                                        value={form.eventName}
                                        className="form-control"
                                      />
                                    </div>

                                    <div className="mb-3 input-group">
                                      <span className="input-group-text">
                                        <FontAwesomeIcon icon={faClipboard} />
                                      </span>
                                      <input
                                        type="text"
                                        name="description"
                                        required
                                        onChange={handleChange}
                                        value={form.description}
                                        placeholder="Enter Description*"
                                        className="form-control"
                                      />
                                    </div>
                                    <button
                                      type="submit"
                                      className="btn mb-3 float-end"
                                      style={{ backgroundColor: "#681DC0", color: "white" }}
                                    >
                                      Submit
                                    </button>
                                  </>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section> */}


                {/*  Your modal component */}
                <Modal
                  size="md"
                  show={lgShow}
                  onHide={() => setLgShow(false)}
                  aria-labelledby="example-modal-sizes-title-lg"
                  centered
                >
                  <div style={{ position: "relative", width: "100%" }}>
                    <img
                      src="/promotional.png" //{URLS.Base + PopUp.image}
                      alt="Promotional popup"
                      style={{ width: "100%", objectFit: "cover" }}
                    />
                    <button
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        background: "rgba(0, 0, 0, 0.5)",
                        border: "none",
                        color: "white",
                        padding: "5px 10px",
                        borderRadius: "5px",
                        cursor: "pointer",
                      }}
                      onClick={() => setLgShow(false)}
                    >
                      &times;
                    </button>
                  </div>
                </Modal>
                <ToastContainer />
                <Footer />
              </>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Home;
